const blockHubspotForms = document.querySelectorAll<HTMLElement>('[data-hubspot-form]');
blockHubspotForms.forEach((el) => {
	window.hbspt.forms.create({
		portalId: el.getAttribute('data-hubspot-portal-id'),
		formId: el.getAttribute('data-hubspot-form'),
		target: '#' + el.id,
		cssRequired: '',
		css: '',
		locale: document.documentElement.getAttribute('lang'),
	});
});

/**
 * Animates the submit button by transforming its text content into a structured
 * HTML markup. It extracts the original text, clears the button, and then
 * inserts a new `<span>` structure with the original text stored in a `data-text` attribute.
 * This function is intended to be called when the DOM is ready to ensure the button element exists.
 */
const animateSubmitButton = () => {
	const submitButtons = document.querySelectorAll<HTMLButtonElement>(
		'.frm_forms form .frm_form_fields .frm_form_field .frm_submit .frm_button_submit'
	);

	if (submitButtons && submitButtons.length > 0) {
		submitButtons.forEach((submitButton) => {
			if (submitButton) {
				const btnText: string = submitButton.textContent || '';
				submitButton.textContent = '';

				// Split text into words like the PHP function does
				const words = btnText.trim().split(/\s+/);
				const wordCount = words.length;

				let newMarkup = '<span class="btn-inner">';
				words.forEach((word, index) => {
					newMarkup += `<span class="btn-words" style="--word-index: ${index + 1}; --word-count: ${wordCount};">`;
					newMarkup += `<span class="btn-words__visible">${word}</span>`;
					newMarkup += `<span class="btn-words__clone">${word}</span>`;
					newMarkup += '</span>';
					// Add space between words (except after the last word)
					if (index < wordCount - 1) {
						newMarkup += ' ';
					}
				});
				newMarkup += '</span>';

				submitButton.insertAdjacentHTML('afterbegin', newMarkup);
				submitButton.classList.add('btn-primary');
			}
		});
	}
};
document.addEventListener('DOMContentLoaded', () => {
	animateSubmitButton();
});
